<template>
  <div>
    <Modal
      title="添加组委会成员"
      width="1100"
      :value="showMembers"
      :mask-closable="false"
      :footer-hide="true"
      @on-visible-change="visibleChange"
    >
      <div style="margin-bottom: 20px">
        <Button
          @click="openTab('library')"
          :class="activeTab === 'library' ? 'active-tab' : ''"
          >学者库</Button
        >
        <Button
          style="margin-left: 10px"
          @click="openTab('form')"
          :class="activeTab === 'form' ? 'active-tab' : ''"
          >+ 添加成员</Button
        >
      </div>
      <!-- 已选学者列表 -->
      <div class="selected-table" v-if="activeTab === 'isSelect'">
        <Table
          ref="selectTable"
          :columns="selectedColumns"
          :data="tableList"
          @on-select="isOnSelect"
          @on-select-cancel="isOnSelectC"
          @on-select-all="isOnSelectAll"
          @on-select-all-cancel="isOnSelectAllC"
          no-data-text="暂无可选择组委会成员"
        >
          <template slot-scope="{ row }" slot="headImg">
            <img
              v-if="row.headImg"
              :src="$global.imgUrl + row.headImg"
              style="width: 50px; height: 50px; border-radius: 50%"
              alt=""
            />
            <Big v-else width="50" height="50" size="20" :big="row.userName" />
          </template>
          <template slot-scope="{ row }" slot="titles">
            <div
              style="
                width: 90px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-right: 5px;
              "
            >
              <span v-for="item in row.titles" :key="item.id">{{
                item.levelTwo
              }}</span>
            </div>
          </template>
          <template slot-scope="{ row }" slot="disciplineFields">
            <div
              style="
                width: 90px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-right: 5px;
              "
            >
              <span v-for="item in row.disciplineFields" :key="item.id">
                {{ item.levelTwoName }}</span
              >
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <Poptip
              trigger="hover"
              content="采编库挑选成员无法修改"
              v-if="row.type === 1"
            >
              <Icon
                type="md-create"
                size="20"
                style="margin-right: 10px; cursor: not-allowed"
              />
            </Poptip>
            <Icon
              v-else
              type="md-create"
              size="20"
              style="margin-right: 10px; cursor: pointer"
              @click="modify(row)"
            />
            <Icon
              style="cursor: pointer"
              type="ios-trash-outline"
              size="20"
              @click="selectedPageChangeDel(row)"
            />
          </template>
        </Table>
        <Page
          style="text-align: center; margin: 30px 0"
          :current="selectCurrent"
          :total="isSelectList.length"
          :page-size="5"
          show-total
          @on-change="selectedListPageChange"
        >
          共 {{ isSelectList.length }} 个
        </Page>
        <div style="text-align: center">
          <Button
            type="primary"
            size="large"
            @click="$emit('closeModal', selectedList)"
            >确定</Button
          >
        </div>
      </div>
      <!-- 学者库 -->
      <div class="library-table" v-else-if="activeTab === 'library'">
        <div style="margin-bottom: 20px; text-align: center">
          <Input
            style="width: 30%"
            size="large"
            placeholder="请输入学者姓名"
            search
            :value="searchParams.name"
            @on-search="search"
          />
        </div>
        <Table
          ref="searchTable"
          :columns="searchColumns"
          :data="searchTableList"
          @on-select="onSearchSelect"
          @on-select-cancel="onSearchSelectC"
          @on-select-all="OnSearchSelectAll"
          @on-select-all-cancel="onSearchSelectAllC"
        >
          <template slot-scope="{ row }" slot="headPhoto">
            <img
              v-if="row.headPhoto"
              :src="$global.imgUrl + row.headPhoto"
              style="width: 50px; height: 50px; border-radius: 50%"
              alt=""
            />
            <Big v-else width="50" height="50" size="20" :big="row.name" />
          </template>
          <template slot-scope="{ row }" slot="title">
            <span v-for="item in row.title" :key="item.id">{{
              item.levelTwo
            }}</span>
          </template>
          <template slot-scope="{ row }" slot="subject">
            <div
              style="
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              v-for="item in row.subject"
              :key="item.id"
            >
              {{ item.levelTwoName }}
            </div>
          </template>
        </Table>
        <Page
          style="text-align: center; margin: 30px 0"
          :total="searchTotal"
          :current="searchParams.pageNo"
          :page-size="5"
          show-total
          @on-change="searchPageChange"
        >
          共 {{ searchTotal }} 个
        </Page>
        <div style="text-align: center">
          <Button type="primary" size="large" @click="searchSubmit"
            >确定</Button
          >
        </div>
      </div>
      <!-- 添加成员表单 -->
      <div v-else-if="activeTab === 'form'">
        <div style="text-align: center">
          <Form
            style="width: 60%"
            ref="membersValidate"
            :model="membersForm"
            :rules="ruleValidate"
            :label-width="120"
            label-position="left"
          >
            <FormItem label="姓名" prop="userName">
              <Input
                v-model="membersForm.userName"
                placeholder="请输入姓名"
                maxlength="10"
              ></Input>
            </FormItem>
            <FormItem label="学者头像">
              <Upload
                style="text-align: left"
                key="coverImg"
                accept=".png,.jpg,.jpeg"
                :headers="{ token: token }"
                :format="['jpg', 'jpeg', 'png']"
                :show-upload-list="false"
                :max-size="1024"
                :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
                :on-exceeded-size="handleMaxSize"
                :on-success="headPhotoSuccess"
              >
                <img
                  class="img"
                  v-if="membersForm.headImg.length !== 0"
                  v-lazy="$global.imgUrl + membersForm.headImg"
                  alt
                />
                <img
                  v-else
                  class="img"
                  src="@/assets/img/userInfo/add.png"
                  alt
                />
              </Upload>
            </FormItem>
            <FormItem label="工作单位" prop="orgName">
              <Input
                v-model="membersForm.orgName"
                placeholder="请输入工作单位"
                maxlength="20"
              ></Input>
            </FormItem>
            <FormItem label="现任职位">
              <Input
                v-model="membersForm.position"
                placeholder="请输入现任职位"
                maxlength="20"
              ></Input>
            </FormItem>
            <FormItem label="职称">
              <div
                class="item-list"
                v-for="(item, index) in membersForm.titles"
                :key="index"
              >
                <Select
                  v-model="item.levelOne"
                  style="width: 45%; margin-right: 10px"
                >
                  <Option
                    v-for="item in subjectOption"
                    :key="item.titleCode"
                    :value="item.titleCode"
                    >{{ item.titleName }}</Option
                  >
                </Select>
                <Input
                  v-model="item.levelTwo"
                  placeholder="请输入职称"
                  maxlength="20"
                ></Input>
                <Icon
                  style="margin-left: 5px; cursor: pointer"
                  :type="
                    index < membersForm.titles.length - 1 || index === 4
                      ? 'md-remove-circle'
                      : 'md-add-circle'
                  "
                  size="26"
                  color="#999999"
                  @click="titleArrBtn(index)"
                />
              </div>
            </FormItem>
            <FormItem label="学科领域">
              <div
                class="item-list"
                v-for="(item, index) in membersForm.disciplineFields"
                :key="index"
              >
                <Cascader
                  style="width: 100%"
                  :data="titleOption"
                  :value="[item.levelOne, item.levelTwo]"
                  filterable
                  trigger="hover"
                  placeholder="请输入学科领域"
                  @on-change="
                    (value) => {
                      subjectsChange(value, index);
                    }
                  "
                ></Cascader>
                <Icon
                  style="margin-left: 5px; cursor: pointer"
                  :type="
                    index < membersForm.disciplineFields.length - 1 ||
                    index === 4
                      ? 'md-remove-circle'
                      : 'md-add-circle'
                  "
                  size="26"
                  color="#999999"
                  @click="fieldArrBtn(index)"
                />
              </div>
            </FormItem>
            <FormItem label="研究方向">
              <Input
                v-model="membersForm.researchDirection"
                placeholder="请输入研究方向"
                maxlength="20"
              ></Input>
            </FormItem>
          </Form>
          <Button
            v-throttleClick
            type="primary"
            size="large"
            @click="formSubmit"
            >确定</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["token"]),
  },
  props: {
    isArr: {
      type: Array,
    },
    showMembers: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: "isSelect",

      selectedColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "头像",
          slot: "headImg",
        },
        {
          title: "姓名",
          ellipsis: "true",
          tooltip: "true",
          key: "userName",
        },
        {
          title: "工作单位",
          key: "orgName",
          ellipsis: "true",
          tooltip: "true",
        },
        {
          title: "现任职位",
          ellipsis: "true",
          tooltip: "true",
          key: "position",
        },
        {
          title: "职称",
          slot: "titles",
        },
        {
          title: "研究领域",
          slot: "disciplineFields",
        },
        {
          title: "研究方向",
          key: "researchDirection",
          ellipsis: "true",
          tooltip: "true",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      selectedList: [], // 已选界面表格选中的数据
      tableList: [], // 已选界面的表格展示的数据
      isSelectList: [], // 从学者库或者表单添加到已选界面表格的数据
      selectCurrent: 1,

      searchColumns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "头像",
          slot: "headPhoto",
        },
        {
          title: "姓名",
          ellipsis: "true",
          tooltip: "true",
          key: "name",
        },
        {
          title: "工作单位",
          key: "unit",
          ellipsis: "true",
          tooltip: "true",
        },
        {
          title: "现任职位",
          ellipsis: "true",
          tooltip: "true",
          key: "job",
        },
        {
          title: "职称",
          slot: "title",
        },
        {
          title: "研究领域",
          slot: "subject",
        },
        {
          title: "研究方向",
          key: "researchDirection",
          ellipsis: "true",
          tooltip: "true",
        },
        {
          title: "手机",
          key: "mobile",
          ellipsis: "true",
          tooltip: "true",
        },
      ],
      searchTableList: [],
      isSearchList: [],
      searchTotal: 0,
      searchParams: {
        type: 2,
        name: "",
        pageNo: 1,
        pageSize: 5,
      },

      membersForm: {
        customId: "",
        userName: "",
        headImg: "",
        orgName: "",
        position: "",
        titles: [
          {
            levelOne: "",
            levelTwo: "",
          },
        ],
        disciplineFields: [
          {
            levelOne: "",
            levelOneName: "",
            levelTwo: "",
            levelTwoName: "",
          },
        ],
        researchDirection: "",
        type: 2,
      },
      subjectOption: [],
      titleOption: [],
      ruleValidate: {
        userName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
        ],
        orgName: [
          { required: true, message: "工作单位不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    visibleChange(query) {
      if (query) {
        this.selectedList = [...this.isArr];
        if (this.isSelectList.length === 0) this.isSelectList = [...this.isArr];
        this.selectedListPageChange();
      } else {
        this.$emit("closeModal");
      }
    },
    // 切换表格或者表单TAB
    openTab(tab) {
      if (tab === "library") {
        // 学者库
        this.getSearchTableList(); //调取学者库列表
      } else if (tab === "form") {
        // 添加成员表单
        this.getFormSubOption(); // 获取下拉框Option
        this.getFormTitleOption(); // 获取下拉框Option
      }
      this.activeTab = tab;
    },

    //修改新添加的成员
    modify(query) {
      this.membersForm = {
        customId: query.customId ? query.customId : query.id,
        userName: query.userName,
        headImg: query.headImg,
        orgName: query.orgName,
        position: query.position,
        titles:
          query.titles.length > 0
            ? query.titles
            : [
                {
                  levelOne: "",
                  levelTwo: "",
                },
              ],
        disciplineFields:
          query.disciplineFields.length > 0
            ? query.disciplineFields
            : [
                {
                  levelOne: "",
                  levelOneName: "",
                  levelTwo: "",
                  levelTwoName: "",
                },
              ],
        researchDirection: query.researchDirection,
        type: 2,
      };
      this.openTab("form");
    },
    // 单个选择已选库列表
    isOnSelect(selection, row) {
      this.selectedList.push(row);
    },
    // 单个取消选择已选库列表
    isOnSelectC(selection, row) {
      this.selectedList = this.selectedList.filter(
        (item) => item.id !== row.id
      );
    },
    // 全部选择已选库列表
    isOnSelectAll(selection) {
      selection.forEach((item) => {
        if (
          !this.selectedList.some((i) => {
            return i.id === item.id;
          })
        ) {
          this.selectedList.push(item);
        }
      });
    },
    // 全部取消已选库列表
    isOnSelectAllC(selection) {
      this.tableList.forEach((item) => {
        this.selectedList = this.selectedList.filter((i) => i.id !== item.id);
      });
    },
    // 判断是否已经存在已选项
    isSelectChecked() {
      let objData = this.$refs.selectTable.objData; //拿到当前table的值
      for (let index in objData) {
        if (this.selectedList.some((item) => item.id === objData[index].id)) {
          objData[index]._isChecked = true; //重新勾选
        }
      }
    },
    // 可选组委会成员表格分页获取数据
    selectedListPageChange(page = 1) {
      this.selectCurrent = page;
      let arr = [];
      if (this.isSelectList.length > 5) {
        arr = this.isSelectList.slice(5 * (page - 1), 5 * page);
      } else {
        arr = [...this.isSelectList];
      }
      this.tableList = arr;
      this.$nextTick(() => {
        this.isSelectChecked();
      });
    },
    // 从已选表李删除
    selectedPageChangeDel(obj) {
      console.log(obj,'obj');
      if (obj.type === 2 && obj.customId) {
        this.isSelectList = this.isSelectList.filter(
          (item) => item.customId !== obj.customId
        );
        if (this.selectedList.some((item) => item.customId === obj.customId)) {
          this.selectedList = this.selectedList.filter(
            (item) => item.customId !== obj.customId
          );
        }
      } else {
        this.isSelectList = this.isSelectList.filter(
          (item) => item.id !== obj.id
        );
        if (this.selectedList.some((item) => item.id === obj.id)) {
          this.selectedList = this.selectedList.filter(
            (item) => item.id !== obj.id
          );
        }
      }
      this.$emit("delList", obj);
      this.selectedListPageChange();
    },

    // 学者库表格
    async getSearchTableList() {
      let res = await this.$apis.searchServe.userList(this.searchParams);
      this.searchTableList = res.data.list.map((item) => item.userInfo);
      this.searchTotal = +res.data.total;
      this.$nextTick(() => {
        this.searchChecked();
      });
    },
    // 学者库搜索
    search(query) {
      this.searchParams.name = query;
      this.searchParams.pageNo = 1;
      this.getSearchTableList();
    },
    // 学者库分页
    searchPageChange(page) {
      this.searchParams.pageNo = page;
      this.getSearchTableList();
    },
    // 学者库tabel列表判断是否已经存在已选表中
    searchChecked() {
      let objData = this.$refs.searchTable.objData; //拿到当前table的值
      for (let index in objData) {
        if (this.isSelectList.some((item) => item.id === objData[index].id)) {
          objData[index]._isChecked = true; //重新勾选
        }
      }
    },
    // 选中学者库某一项
    onSearchSelect(selection, row) {
      this.isSelectList.push({
        id: row.id,
        headImg: row.headPhoto, // 头像
        userName: row.name, // 名字
        orgId: row.orgId, // 工作单位ID
        orgName: row.unit, // 单位名称
        position: row.job, // 现任职位
        titles: row.title, // 职称
        disciplineFields: row.subject, // 领域
        researchDirection: row.researchDirection, // 方向
        type: 1, // 代表从学者库选择的
      });
    },
    // 取消选中学者库某一项
    onSearchSelectC(selection, row) {
      this.isSelectList = this.isSelectList.filter(
        (item) => item.id !== row.id
      );
    },
    // 全部选中学者库
    OnSearchSelectAll(selection) {
      selection.forEach((item) => {
        if (
          !this.isSelectList.some((i) => {
            return i.id === item.id;
          })
        ) {
          this.isSelectList.push({
            id: item.id,
            headImg: item.headPhoto, // 头像
            userName: item.name, // 名字
            orgId: item.orgId, // 工作单位ID
            orgName: item.unit, // 单位名称
            position: item.job, // 现任职位
            titles: item.title, // 职称
            disciplineFields: item.subject, // 领域
            researchDirection: item.researchDirection, // 方向
            type: 1, // 代表从学者库选择的
          });
        }
      });
    },
    // 全部取消选中学者库
    onSearchSelectAllC(selection, row) {
      this.searchTableList.forEach((item) => {
        this.isSelectList = this.isSelectList.filter((i) => i.id !== item.id);
      });
    },
    // 学者库选中提交按钮
    searchSubmit() {
      this.activeTab = "isSelect";
      this.selectedListPageChange();
    },

    clearForm() {
      this.$refs.membersValidate.resetFields();
      this.membersForm = {
        customId: "",
        userName: "",
        headImg: "",
        orgName: "",
        position: "",
        titles: [
          {
            levelOne: "",
            levelTwo: "",
          },
        ],
        disciplineFields: [
          {
            levelOne: "",
            levelOneName: "",
            levelTwo: "",
            levelTwoName: "",
          },
        ],
        researchDirection: "",
        type: 2,
      };
    },
    // 添加成员表单
    formSubmit() {
      this.$refs.membersValidate.validate(async (valid) => {
        if (valid) {
          this.activeTab = "isSelect";
          if (this.membersForm.customId) {
            //修改
            this.isSelectList.forEach((item, index) => {
              if (item.customId === this.membersForm.customId) {
                this.isSelectList[index] = {
                  customId: this.membersForm.customId, // 自定义识别的id
                  headImg: this.membersForm.headImg, // 头像
                  userName: this.membersForm.userName, // 名字
                  orgName: this.membersForm.orgName, // 单位名称
                  position: this.membersForm.position, // 现任职位
                  titles: this.membersForm.titles.filter((item) => {
                    return item.levelOne !== "" && item.levelTwo !== "";
                  }), // 职称
                  disciplineFields: this.membersForm.disciplineFields.filter(
                    (item) => {
                      return item.levelOne !== "" && item.levelTwo !== "";
                    }
                  ), // 领域
                  researchDirection: this.membersForm.researchDirection, // 方向
                  type: 2, // 代表从学者库选择的
                };
              }
              this.selectedListPageChange(this.selectCurrent);
            });
          } else {
            //新增
            this.isSelectList.push({
              customId: Date.parse(new Date()), // 自定义识别的id
              headImg: this.membersForm.headImg, // 头像
              userName: this.membersForm.userName, // 名字
              orgName: this.membersForm.orgName, // 单位名称
              position: this.membersForm.position, // 现任职位
              titles: this.membersForm.titles.filter((item) => {
                return item.levelOne !== "" && item.levelTwo !== "";
              }), // 职称
              disciplineFields: this.membersForm.disciplineFields.filter(
                (item) => {
                  return item.levelOne !== "" && item.levelTwo !== "";
                }
              ), // 领域
              researchDirection: this.membersForm.researchDirection, // 方向
              type: 2, // 代表从学者库选择的
            });

            this.selectedListPageChange();
          }
          this.clearForm();
        } else {
          this.$Message.error("填写错误,请检查后重新提交");
        }
      });
    },
    // 图片上传
    headPhotoSuccess(res) {
      this.membersForm.headImg = res.content.url;
    },
    // 图片上传超过限制大小
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    // 职称添加多个按钮
    titleArrBtn(index) {
      if (index < this.membersForm.titles.length - 1 || index === 4) {
        this.membersForm.titles.splice(index, 1);
      } else {
        this.membersForm.titles.push({
          levelOne: "",
          levelTwo: "",
        });
      }
    },
    // 选择学科领域下拉列表选项触发
    subjectsChange(value, index) {
      let One = "";
      let Two = "";
      this.titleOption.forEach((item) => {
        if (item.value === value[0]) {
          One = item.label;
          item.children.forEach((i) => {
            if (i.value === value[1]) {
              Two = i.label;
            }
          });
        }
      });
      this.membersForm.disciplineFields[index].levelOne = value[0];
      this.membersForm.disciplineFields[index].levelOneName = One;
      this.membersForm.disciplineFields[index].levelTwo = value[1];
      this.membersForm.disciplineFields[index].levelTwoName = Two;
    },
    // 学科领域添加多个按钮
    fieldArrBtn(index) {
      if (index < this.membersForm.disciplineFields.length - 1 || index === 4) {
        this.membersForm.disciplineFields.splice(index, 1);
      } else {
        this.membersForm.disciplineFields.push({
          levelOne: "",
          levelOneName: "",
          levelTwo: "",
          levelTwoName: "",
        });
      }
    },
    // 获取学科领域下拉框数据
    async getFormSubOption() {
      const { data } = await this.$apis.userServe.getRelationList();
      this.titleOption = [...data];
    },
    // 获取职称级别下拉框数据
    async getFormTitleOption() {
      const { data } = await this.$apis.userServe.getTitleList();
      this.subjectOption = [...data];
    },
  },
};
</script>

<style lang="scss" scoped>
.active-tab {
  border: 1px solid #2d8cf0;
  background-color: #2d8cf0;
  color: #fff;
}
.item-list {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.img {
  width: 50px;
  height: 50px;
}
::v-deep .ivu-table-row {
  height: 70px;
}
</style>